import { useContext } from "react";
import { CrmSpecificationsContext } from "../contexts/CrmSpecificationsContext";

// ----------------------------------------------------------------------

const useCrmSpecifications = () => useContext(CrmSpecificationsContext);

export default useCrmSpecifications;
